import { createEventBus } from "../Common/eventBusFactory";

export const eventBus = createEventBus();

export const EVENT_LOCATION_OPEN = "onEventLocationOpen";

export const CONTACT_INFO_OPEN = "onContactInfoOpen";

export const EVENT_STATUS_OPEN = "onEventStatusOpen";
